// Состояние фильтров поиска свободных и его перевод в параметры запроса.
//
// Состав узкий и продиктован сервером: free_cars_for_rent_v2 пропускает набор
// apply_cars_filters (состояние, тип, коробка, топливо, теги) плюс три фильтра,
// живущих только в этом экшене (места, кондиционер, залог). Всё, чего в этом наборе
// нет, фильтровать нечем — класть такой параметр в запрос значило бы показать
// пользователю фильтр, который сервер молча игнорирует.

// Состояния, отмеченные при открытии страницы: то же, что сервер применяет без
// параметра (FREE_SEARCH_STATES). Они предвыбраны, а не подразумеваются молча —
// иначе не видно, что в «свободные» попадают машины в ремонте, в долгосрочной
// аренде и требующие обслуживания: менеджер звонит клиенту по машине, которую
// нельзя выдать.
export const SEARCH_FREE_DEFAULT_STATES = [1, 2, 4, 6];

// А выбрать можно все шесть: «критическое» и «не выдавать» сняты, но доступны —
// свободную машину в критическом состоянии менеджер хочет увидеть, чтобы решить,
// чинить ли её под конкретную бронь. Сервер такое расширение принимает.
export const SEARCH_FREE_SELECTABLE_STATES = [1, 2, 3, 4, 5, 6];

export function defaultSearchFreeFilters() {
  return {
    state: [...SEARCH_FREE_DEFAULT_STATES],
    car_type: null,
    transmission: null,
    fuel: null,
    tag_ids: [],
    min_seats: null,
    is_air: false,
    no_deposit: false,
  };
}

// Все ли состояния отмечены — тогда это не фильтр, а исходное положение, и чипа не надо.
export function isDefaultStates(state) {
  const list = Array.isArray(state) ? state : [];
  return list.length === SEARCH_FREE_DEFAULT_STATES.length &&
    SEARCH_FREE_DEFAULT_STATES.every((s) => list.indexOf(s) !== -1);
}

// Снятые все до одного состояния — это «ничего не показывать». Сервер так не умеет:
// пустой state он трактует как отсутствие фильтра и вернёт все четыре. Поэтому
// пустой выбор обрабатывается на фронте, запросом его выразить нельзя.
export function noStatesSelected(filters) {
  const f = filters || {};
  return Array.isArray(f.state) && f.state.length === 0;
}

// Пустые значения в запрос не кладём: сервер трактует присутствие параметра как
// намерение фильтровать.
export function searchFreeFilterParams(filters) {
  const f = filters || {};
  const params = {};
  if (Array.isArray(f.state) && f.state.length) params.state = f.state;
  if (f.car_type) params.car_type = f.car_type;
  if (f.transmission) params.transmission = f.transmission;
  if (f.fuel) params.fuel = f.fuel;
  if (Array.isArray(f.tag_ids) && f.tag_ids.length) params.tag_ids = f.tag_ids;
  const seats = parseInt(f.min_seats, 10);
  if (Number.isFinite(seats) && seats > 0) params.min_seats = seats;
  // false — это «неважно», а не «без кондиционера»: фильтра на отсутствие нет
  if (f.is_air === true) params.is_air = true;
  if (f.no_deposit === true) params.no_deposit = true;
  return params;
}
